<span class="badge badge-info">
    <i class="fas fa-user-plus"></i> Aquisição
</span>